const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
export const PASSWORD_MIN = 8;

const emailError = (email) => {
  if (!email.trim()) return "Email is required.";
  if (!EMAIL_RE.test(email.trim())) return "Enter a valid email address.";
  return null;
};

const clean = (errors) => Object.fromEntries(Object.entries(errors).filter(([, v]) => v));

export function validateLogin({ email, password }) {
  return clean({ email: emailError(email), password: password ? null : "Password is required." });
}

export function validateSignup({ fullName, email, password }) {
  const name = fullName.trim();
  return clean({
    fullName: !name ? "Full name is required." : name.length < 2 ? "Enter your full name." : null,
    email: emailError(email),
    password: !password
      ? "Password is required."
      : password.length < PASSWORD_MIN
        ? `Use at least ${PASSWORD_MIN} characters.`
        : password.length > 72
          ? "Use 72 characters or fewer."
          : null,
  });
}
